// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2X5pB","colBig":"styles_colBig__33M_j","colSmall":"styles_colSmall__OVEAP","shopifyNameWrapper":"styles_shopifyNameWrapper__2BMbb"};